import React from "react";

/* ---------- Icons ---------- */
function IconWrap({ children }) {
  return (
    <div
      style={{
        width: "52px",
        height: "52px",
        borderRadius: "14px",
        background: "#f2f7fd",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        marginBottom: "20px",
      }}
    >
      {children}
    </div>
  );
}

const iconProps = {
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "#7f47ec",
  strokeWidth: 1.8,
  strokeLinecap: "round",
  strokeLinejoin: "round",
};

const Icons = {
  award: (
    <svg {...iconProps}>
      <circle cx="12" cy="8" r="5" />
      <path d="M8.5 12.5L7 22l5-3 5 3-1.5-9.5" />
    </svg>
  ),
  sparkle: (
    <svg {...iconProps}>
      <path d="M12 3l1.5 4.5L18 9l-4.5 1.5L12 15l-1.5-4.5L6 9l4.5-1.5L12 3z" />
      <path d="M19 15l.7 2.1L22 18l-2.3.9L19 21l-.7-2.1L16 18l2.3-.9L19 15z" />
    </svg>
  ),
  rocket: (
    <svg {...iconProps}>
      <path d="M12 2c2.5 2 4 5 4 9-1 1-2 1.5-4 1.5S9 12 8 11c0-4 1.5-7 4-9z" />
      <path d="M8 13l-3 3 1 4 4-1" />
      <path d="M16 13l3 3-1 4-4-1" />
      <circle cx="12" cy="9" r="1.2" fill="#7f47ec" stroke="none" />
    </svg>
  ),
  factory: (
    <svg {...iconProps}>
      <path d="M3 21V10l6 4v-4l6 4v-4l6 4v7H3z" />
      <path d="M6 21v-3M11 21v-3M16 21v-3" />
    </svg>
  ),
  people: (
    <svg {...iconProps}>
      <circle cx="9" cy="8" r="3" />
      <path d="M3 21v-2a4 4 0 0 1 4-4h4a4 4 0 0 1 4 4v2" />
      <circle cx="17.5" cy="9.5" r="2.2" />
      <path d="M16 21v-1.5a3 3 0 0 0-1-2.2" />
    </svg>
  ),
  docCheck: (
    <svg {...iconProps}>
      <path d="M8 3h6l4 4v12a1 1 0 0 1-1 1H8a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1z" />
      <path d="M14 3v4h4" />
      <path d="M9.5 14.5l1.5 1.5 3.5-3.5" />
    </svg>
  ),
  gradCap: (
    <svg {...iconProps}>
      <path d="M12 3l10 5-10 5-10-5 10-5z" />
      <path d="M6 10.5V16c0 1.5 2.7 3 6 3s6-1.5 6-3v-5.5" />
    </svg>
  ),
  heartCheck: (
    <svg {...iconProps}>
      <path d="M12 20s-7-4.4-9.5-9C1 8 2.5 5 6 5c2 0 3.3 1.1 4 2.2C10.7 6.1 12 5 14 5c3.5 0 5 3 3.5 6-.4.8-.9 1.5-1.5 2.2" />
      <path d="M14 16l2 2 4-4" />
    </svg>
  ),
};

/* ---------- Data ---------- */
const CARDS = [
  {
    icon: "award",
    title: "Innovation Awards",
    description: "Recognise outstanding innovations across sectors.",
  },
  {
    icon: "sparkle",
    title: "Innovator of the Year",
    description: "Celebrate individuals who create meaningful impact.",
  },
  {
    icon: "rocket",
    title: "Best Prototype",
    description: "Recognise promising prototype developments.",
  },
  {
    icon: "factory",
    title: "Best Facility Centre",
    description: "Centres that make exceptional contributions.",
  },
  {
    icon: "people",
    title: "Expert Excellence",
    description: "Experts with significant mentorship impact.",
  },
  {
    icon: "docCheck",
    title: "Made-in-AP Product",
    description: "Products developed through the ecosystem.",
  },
  {
    icon: "gradCap",
    title: "Emerging Innovator",
    description: "Students and first-time inventors.",
  },
  {
    icon: "heartCheck",
    title: "People's Recognition",
    description: "Grassroots innovations solving everyday problems.",
  },
];

function Card({ icon, title, description }) {
  return (
    <div
      style={{
        background: "#FFFFFF",
        border: "1px solid #E5EAF1",
        borderRadius: "16px",
        padding: "28px 24px",
        boxShadow: "0 1px 2px rgba(16, 24, 40, 0.03)",
      }}
    >
      <IconWrap>{Icons[icon]}</IconWrap>
      <h3
        style={{
          fontSize: "19px",
          fontWeight: 700,
          color: "#0B1F3A",
          margin: "0 0 10px 0",
          lineHeight: 1.3,
        }}
      >
        {title}
      </h3>
      <p
        style={{
          fontSize: "15px",
          color: "#5B6779",
          margin: 0,
          lineHeight: 1.55,
        }}
      >
        {description}
      </p>
    </div>
  );
}

export default function RecognitionAwards() {
  return (
    <section
      style={{
        background:
          "linear-gradient(135deg, #EAF3FC 0%, #F3F8FD 45%, #E9F5FB 100%)",
        padding: "72px 24px",
        fontFamily:
          "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
      }}
    >
      <div style={{ maxWidth: "1180px", margin: "0 auto" }}>
        {/* Header */}
        <div style={{ textAlign: "center", marginBottom: "48px" }}>
          <span
            style={{
              display: "inline-block",
              fontSize: "13px",
              fontWeight: 700,
              letterSpacing: "1.5px",
              color: "#7f47ec",
              marginBottom: "12px",
              textTransform: "uppercase",
            }}
          >
            Recognition &amp; Awards
          </span>
          <h2
            style={{
              fontSize: "44px",
              fontWeight: 800,
              color: "#0B1F3A",
              margin: 0,
              lineHeight: 1.25,
            }}
          >
            Every Great Innovation
            <br />
            Deserves to <span style={{ color: "#7f47ec" }}>Be Seen.</span>
          </h2>
        </div>

        {/* Grid */}
        <div
          className="ra-grid"
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(4, 1fr)",
            gap: "22px",
            marginBottom: "48px",
          }}
        >
          {CARDS.map((card) => (
            <Card
              key={card.title}
              icon={card.icon}
              title={card.title}
              description={card.description}
            />
          ))}
        </div>

        {/* Closing quote */}
        <p
          style={{
            textAlign: "center",
            fontStyle: "italic",
            fontSize: "20px",
            color: "#3B4657",
            maxWidth: "760px",
            margin: "0 auto",
            lineHeight: 1.6,
          }}
        >
          Not every idea will become a billion-dollar company. But every
          sincere idea deserves an opportunity to be{" "}
          <span style={{ color: "#7f47ec", fontWeight: 700 }}>
            heard, explored and recognised.
          </span>
        </p>
      </div>

      <style>{`
        @media (max-width: 1024px) {
          .ra-grid {
            grid-template-columns: repeat(2, 1fr) !important;
          }
        }
        @media (max-width: 560px) {
          .ra-grid {
            grid-template-columns: 1fr !important;
          }
          h2 {
            font-size: 32px !important;
          }
        }
      `}</style>
    </section>
  );
}